import serviceRequest from "utils/request";

const baseUrl = "/requesthandling";

export const getOutputData = (params) => {
	return serviceRequest({
		url: `${baseUrl}/output`,
		method: "get",
		params,
	});
};

export const getPublicationData = (params) => {
	return serviceRequest({
		url: `${baseUrl}/publication`,
		method: "get",
		params,
	});
};

export const getServiceRequest = (params) => {
	return serviceRequest({
		url: `${baseUrl}/service-request`,
		method: "get",
		params,
	});
};

export const serviceRequestStatusChange = (data) => {
	return serviceRequest({
		url: `${baseUrl}/status/change`,
		method: "post",
		data,
	});
};

export const serviceRequestSendEmail = (data) => {
	return serviceRequest({
		url: `${baseUrl}/status/change/send-email`,
		method: "post",
		data,
	});
};
